module.exports = __webpack_public_path__ + "static/media/avatar-3.bcb662f7.jpg";